import { render, staticRenderFns } from "./CopyRight.vue?vue&type=template&id=e751666e&scoped=true&"
import script from "./CopyRight.vue?vue&type=script&lang=js&"
export * from "./CopyRight.vue?vue&type=script&lang=js&"
import style0 from "./CopyRight.vue?vue&type=style&index=0&id=e751666e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e751666e",
  null
  
)

export default component.exports